// This will apply the mouse wheel prevention to all input[type="number"] elements where the v-prevent-wheel directive is used.
// The directive ensures that the event listener is properly cleaned up when the element is unbound to avoid memory leaks.
// Example: <input type="number" v-prevent-wheel />

export default {
  install(Vue) {
    Vue.directive('prevent-wheel', {
      bind(el, binding, vnode) {
        let handleWheel = (event) => {
          if (el === document.activeElement) {
            event.preventDefault();
          }
        };
        // Add an event listener to the element
        el.addEventListener('wheel', handleWheel);
        // Save the handler function to unbind later if needed
        el._handleWheel = handleWheel;
      },
      unbind(el) {
        // Remove the event listener from the element
        el.removeEventListener('wheel', el._handleWheel);
        el._handleWheel = null;
      }
    });
  },
};
